import {RoadKillGameConfig} from "../RoadKillGameConfig";
import {TimelineLite} from "gsap";
import {RoadKill} from "../RoadKill";
import {RoadKillGameData, RoadKillInitData} from "../server/RoadKillData";
import {RoadKillUtils} from "../utils/RoadKillUtils";
import {SYMBOL_NAME} from "../component/enums/RoadKillEnums";
import {BitMapMultiplier} from "../component/BitmapMultiplier";
import {RoadKillGameAssets} from "../RoadKillGameAssets";
import {JumpingWild} from "../component/JumpingWild";
import {RoadKillGameMode} from "../server/RoadKillGameMode";
import {RKHelper} from "../utils/RKHelper";
import {RoadKillModel} from "../server/RoadKillModel";
import {RoadKillSymbol} from "../reels/RoadKillSymbol";
import {RoadKillSound} from "../sound/RoadKillSound";

export class RoadKillMassiveWinView extends PIXI.Container {
    private _massiveWildSpine: PIXI.spine.Spine;
    private _showHideCoverDuration: number = RoadKillGameConfig.HIDE_AND_ALPHA_DURATION;
    private _beerHitMultipler: BitMapMultiplier;
    private _beerHitMultipler4: BitMapMultiplier;
    private _deerHitMultipliers: BitMapMultiplier[];
    private _originalPositionOfBeerMultiplers: number[] = [360, 543];
    private _movingPositionOfBeerMultiplers: number[] = [484, 165];


    constructor() {
        super();
        this.name = "massiveWinView";
        this.init();
        this.addChild(this._massiveWildSpine, this._beerHitMultipler, this._beerHitMultipler4, this._deerHitMultipliers[0], this._deerHitMultipliers[1], this._deerHitMultipliers[2]);
    }

    public handleRestore(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (RoadKill.model.initData.isRestoreState && !RoadKill.model.gameData && RoadKill.model.initData.totalAnimalHitsSFS === 20) {
            tl.add(this.showIndividualCover());
            tl.add(RoadKill.jumpingWildView.hideShowAllSW(0), "<");
            tl.progress(1);
        }
        return tl;
    }


    public changeReelSWSymToOriginalSyms(): void {
        const gameModel: RoadKillModel = RoadKill.model;
        for (let reelIdx: number = 1; reelIdx <= 3; reelIdx++) {
            for (let symIdx: number = 0; symIdx < gameModel.evaluatedArea[0].length; symIdx++) {
                if (RoadKillGameConfig.WILD_SYMBOLS.includes(gameModel.evaluatedArea[reelIdx][symIdx]) && (RoadKill.reelView.getVisibleSymbolAt(reelIdx, symIdx).symbolName === gameModel.evaluatedArea[reelIdx][symIdx])) {
                    const sym: RoadKillSymbol = RoadKill.reelView.getVisibleSymbolAt(reelIdx, symIdx);
                    sym.changeSymbol(gameModel.reels[reelIdx][symIdx + 1] as SYMBOL_NAME);
                    sym.setNonAlpha(0.55, true);
                }
            }
        }
    }

    public setJumpingWildVisibility(visible: boolean): TimelineLite {
        //to fix #238
        const jw: JumpingWild[] = RoadKill.jumpingWildView.getWilds(),
            tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            for (let idx: number = 0; idx < jw.length; idx++) {
                jw[idx].visible = visible;
            }
        });
        return tl;
    }

    public showIndividualCover(): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onStart: () => {
                RoadKill.topAnimalController.hideCombinedAnimalsHeadCount();// #282
                if (!this._massiveWildSpine.visible) {
                    this._massiveWildSpine.visible = true
                }
            }
        });
        tl.add(RKHelper.playSpineWithTimeline(this._massiveWildSpine, 0, "reveal"));
        return tl;
    }

    public moveJWToPosition(): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            JW: JumpingWild[] = RoadKill.jumpingWildView.getWilds();
        tl.add(() => {
            this.changeReelSWSymToOriginalSyms();
        });
        tl.add(RoadKill.jumpingWildView.hideShowAllSW(1));
        for (let JWIdx: number = 0; JWIdx < JW.length; JWIdx++) {
            tl.add(JW[JWIdx].jumpToPos({reelId: 2, rowId: this.getJWPos(JWIdx)}), 0);
        }
        return tl;
    }

    public updateHeartList(): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            heartList: string[] = RoadKill.model.gameData.heartList;
        tl.add(RoadKill.lifeView.update(heartList));
        return tl;
    }

    public darkenAllSym(): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            data: RoadKillGameData | RoadKillInitData = RoadKill.model.gameData ? RoadKill.model.gameData : RoadKill.model.initData;
        if (!RoadKillUtils.allReelsInIdleState()) {
            return tl;
        }
        for (let reelIdx: number = 0; reelIdx < RoadKillGameConfig.REELS_NUM; reelIdx++) {
            for (let symIdx: number = data.evaluatedArea ? 0 : 1; symIdx < (data.evaluatedArea ? data.evaluatedArea[0].length : data.reels[0].length - 1); symIdx++) {
                const sym = RoadKillUtils.getSymbol(reelIdx, symIdx);
                tl.add(() => {
                    sym.markNonWin(true, 0.7);
                    sym.setSpineAlpha(0);
                }, 0);
            }
        }
        return tl;
    }

    public showFullCover(): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onStart: () => {
                this.setBearMultiplerPos();
                this._beerHitMultipler4.scale.set(1);
                this._beerHitMultipler.scale.set(1);
            }
        });
        tl.add(RKHelper.playSpineWithTimeline(this._massiveWildSpine, 0, "roadblock"));
        tl.to([this._beerHitMultipler, this._beerHitMultipler4], {
            x: this._movingPositionOfBeerMultiplers[0],
            y: this._movingPositionOfBeerMultiplers[1],
            duration: 0.3,
            ease: "back.in(4)"
        });
        tl.to([this._beerHitMultipler.scale, this._beerHitMultipler4.scale], {
            x: 0,
            y: 0,
            duration: 0.3,
            ease: "back.in(4)"
        }, "<");
        tl.add(this.bounceBearHitMultiplier())
        tl.add(this.playSpecificAnimation("idle", true, false));
        return tl;
    }

    public playSpecificAnimation(animName: string, loop: boolean = false, includeInTimeline: boolean = true): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        let trackIdx: number = 0;
        if (animName === "b_hit" || animName === "d_hit" || animName === "r_hit") {
            trackIdx = 1;
        }
        if (includeInTimeline) {
            if (loop) {
                tl.add(() => {
                    this._massiveWildSpine.autoUpdate = true;
                    this._massiveWildSpine.state.setAnimation(trackIdx, animName, true);
                });
                tl.to(this, {duration: this._massiveWildSpine.skeleton.data.findAnimation(animName).duration});
            } else {
                tl.add(RKHelper.playSpineWithTimeline(this._massiveWildSpine, trackIdx, animName));
            }
        } else {
            tl.add(() => {
                this._massiveWildSpine.autoUpdate = true;
                this._massiveWildSpine.state.setAnimation(trackIdx, animName, loop);
            });
        }
        return tl;
    }

    public onReelStart(): void {
        if (RoadKill.model.gameData && RoadKill.model.gameData.doMassiveWildThisSpin) {
            this.hideMassiveWin();
        }
    }

    public showBearHitMutiplier(value: number, duration: number = RoadKillGameConfig.HIDE_AND_ALPHA_DURATION): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onStart: () => {
                this._beerHitMultipler.visible = true;
                this._beerHitMultipler.alpha = 0;
            }
        });
        this._beerHitMultipler.value = value;
        tl.to(this._beerHitMultipler, {alpha: 1, duration: 0.2}, 0);
        return tl;
    }

    public showBearHitMutiplier4(): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onStart: () => {
                this._beerHitMultipler4.visible = true;
                this._beerHitMultipler4.alpha = 0;
            }
        });
        this._beerHitMultipler4.value = 4;
        tl.to(this._beerHitMultipler, {alpha: 0, duration: 0.2});
        tl.to(this._beerHitMultipler4, {alpha: 1, duration: 0.2});
        return tl;

    }

    public showDeerHitMultipliers(): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onStart: () => {
                for (let idx: number = 0; idx < this._deerHitMultipliers.length; idx++) {
                    this._deerHitMultipliers[idx].visible = true;
                    this._deerHitMultipliers[idx].alpha = 0;
                }
            }
        });
        for (let idx: number = 0; idx < this._deerHitMultipliers.length; idx++) {
            tl.to(this._deerHitMultipliers[idx], {alpha: 1, duration: 0.2}, 0);
        }
        return tl;
    }

    private bounceBearHitMultiplier(): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onStart: () => {
                this._beerHitMultipler.scale.set(1);
                this._beerHitMultipler4.scale.set(1);
            }
        });
        tl.to([this._beerHitMultipler.scale, this._beerHitMultipler4.scale], {
            duration: 0.7,
            y: 1.5,
            x: 1.5,
            ease: "bounce.out"
        })
        return tl;
    }

    private getJWPos(idx: number): number {
        if (idx === 0) {
            return 2;
        } else if (idx === 1) {
            return 1;
        } else {
            return 0
        }
    }

    private init(): void {
        this._beerHitMultipler = this.createMultiplier();
        this._beerHitMultipler4 = this.createMultiplier();
        this._deerHitMultipliers = this.createDeerMultipliers();
        this._massiveWildSpine = this.createMassiveWildSpine();
    }

    private createMassiveWildSpine(): PIXI.spine.Spine {
        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(RoadKill.assetLoader.getSpineAsset("roadblock"));
        spine.position.set(360, 360);
        spine.visible = false;
        return spine;
    }

    private createDeerMultipliers(): BitMapMultiplier[] {
        const _multiArray: BitMapMultiplier[] = [];
        for (let idx: number = 0; idx < 3; idx++) {
            _multiArray.push(new BitMapMultiplier(RoadKillGameAssets.BITMAP_FONT_NUMBERS_MULTIPLIER, 24, "x"));
            _multiArray[idx].name = `massiveDeer_${idx}`;
            _multiArray[idx].position = (RoadKillUtils.getSymAbsolutePos(RoadKillGameConfig.REELS_NUM - 1, idx));
            _multiArray[idx].visible = false;
            _multiArray[idx].value = 2;
        }
        return _multiArray;
    }

    private createMultiplier(): BitMapMultiplier {
        const _multi: BitMapMultiplier = new BitMapMultiplier(RoadKillGameAssets.BITMAP_FONT_NUMBERS_MULTIPLIER, 40, "x");
        _multi.position.set(this._originalPositionOfBeerMultiplers[0], this._originalPositionOfBeerMultiplers[1]);
        _multi.visible = false;
        return _multi
    }

    private hideMassiveWin(durr: number = this._showHideCoverDuration): TimelineLite {
        if (RoadKill.model.nextMode !== RoadKillGameMode.NORMAL) {
            this.setJumpingWildVisibility(true);
        }
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                this._beerHitMultipler.visible = false;
                this._beerHitMultipler4.visible = false;
                this._massiveWildSpine.visible = false;
                for (let idx: number = 0; idx < this._deerHitMultipliers.length; idx++) {
                    this._deerHitMultipliers[idx].visible = false;
                }
                this.setBearMultiplerPos();
            }
        });

        tl.to([this._beerHitMultipler, this._beerHitMultipler4], {alpha: 0, duration: durr}, 0);
        for (let idx: number = 0; idx < this._deerHitMultipliers.length; idx++) {
            tl.to(this._deerHitMultipliers[idx], {alpha: 0, duration: durr}, 0);
        }
        tl.add([RKHelper.playSpineWithTimeline(this._massiveWildSpine, 0, "reset"), () => {
            RoadKill.soundPlayer.playTrack(RoadKillSound.ROADBLOCK_DISAPPEAR);
        }]);
        return tl;
    }

    private setBearMultiplerPos(y: number = this._originalPositionOfBeerMultiplers[1], x: number = this._originalPositionOfBeerMultiplers[0]): void {
        this._beerHitMultipler.position.set(x, y);
        this._beerHitMultipler4.position.set(x, y);
    }
}